import React, { cloneElement } from 'react';
import { IconButton, makeStyles, Menu } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { isFunction } from 'lodash';

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.secondary.contrastText,
  },
}));

const ActionField = (props) => {
  const { children } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleChildItemClick = (onClick) => () => {
    setAnchorEl(null);
    if (isFunction(onClick)) onClick();
  };

  if (!children) {
    return null;
  }

  return (
    <div>
      <IconButton
        className={classes.button}
        aria-label="actions menu"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClick={handleClose}
        onClose={handleClose}>
        {React.Children.map(children, (child) =>
          cloneElement(child, {
            ...child.props,
            ...props,
            onClick: handleChildItemClick(child.props.onClick),
          })
        )}
      </Menu>
    </div>
  );
};

export default ActionField;
